import { Img, TextWithIcon } from "ui-kit/components-branded/index"
import style from "modules/Booking/FormPage/components/DepositBannerRegular/style.module.scss"

export function DepositBannerRegular() {
    return (
        <div className={style.container}>
            <TextWithIcon
                icon={<Img src="green-heart-emoji.png" className={style.emoji} />}
                position="left"
            >
                Абонемент поможет заниматься регулярно и&nbsp;записываться без оплаты.
            </TextWithIcon>
        </div>
    )
}
